import { useEffect } from 'react'
import { on } from './eventBus'

/**
 * Subscribe to a platform event for the lifetime of the component.
 * @param {string} event
 * @param {(payload: unknown) => void} handler
 */
export default function usePlatformEvent(event, handler) {
  useEffect(() => on(event, handler), [event, handler])
}
